import { InjectionToken } from '@angular/core';

export const SERVER_PORT = new InjectionToken<any>('SERVER_PORT');
